import clsx from 'clsx';
import { EmblemAnimated } from '@nula/core-ui';
import styles from './assistant-avatar.module.css';

interface AssistantAvatarProps {
  /**
   * When true (the agent is mid-turn — status events are streaming and the
   * final answer hasn't settled), the emblem loops a draw-on cycle so the
   * user sees a clear "the agent is doing something" cue.
   *
   * When false the emblem runs the cycle once and freezes on the filled
   * silhouette — a calm brand anchor with no ongoing motion.
   */
  active: boolean;
  className?: string;
}

/**
 * AssistantAvatar — orb-only draw-on emblem rendered next to the latest
 * assistant message.
 *
 * Thin wrapper around core-ui's EmblemAnimated. The wrapper exposes a
 * boolean `active` instead of the underlying `loop` so callers don't have to
 * think about cycle mechanics — `active` maps to "show me the animation"
 * vs "show me a settled mark".
 */
export function AssistantAvatar({ active, className }: AssistantAvatarProps) {
  return (
    <div
      className={clsx(styles.root, className)}
      data-testid="assistant-avatar"
      data-active={active ? 'true' : 'false'}
      aria-hidden
    >
      <EmblemAnimated
        size={28}
        loop={active}
        duration={1670}
        holdDuration={1000}
        color="var(--outline-variant)"
      />
    </div>
  );
}
